import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import useOwnedCarbonTokens from 'src/common/apollo/hooks/useOwnedCarbonTokens'
import useCarbonBundle from 'src/common/contracts/hooks/carbon-bundles/useCarbonBundle'
import { OwnedNFT } from 'src/common/types/models/Tokens'
import useConfig from 'src/config/hooks/useConfig'
import { viccCountAtom } from '../../bundle-store'

const useCarbonBundleWithdrawTx = () => {
  const viccCount = useAtomValue(viccCountAtom)

  const { withdrawAssets } = useCarbonBundle()
  const { contractsAddresses } = useConfig()

  const { ownedCarbonTokens: carbonInBundle } = useOwnedCarbonTokens(
    contractsAddresses.carbonBundleAddress
  )

  const withdrawnCarbonNfts = useMemo(() => {
    return carbonInBundle ? carbonInBundle.slice(0, viccCount) : []
  }, [carbonInBundle, viccCount])

  const withdrawAssetsTx = useMemo(() => {
    return withdrawAssets(withdrawnCarbonNfts as OwnedNFT[])
  }, [withdrawAssets, withdrawnCarbonNfts])

  return {
    withdrawnCarbonNfts,
    withdrawAssetsTx,
  }
}

export default useCarbonBundleWithdrawTx
